import { render, staticRenderFns } from "./ArriveEmbassy.vue?vue&type=template&id=2a104543&scoped=true"
import script from "./ArriveEmbassy.vue?vue&type=script&lang=js"
export * from "./ArriveEmbassy.vue?vue&type=script&lang=js"
import style0 from "./ArriveEmbassy.vue?vue&type=style&index=0&id=2a104543&prod&lang=less"
import style1 from "./ArriveEmbassy.vue?vue&type=style&index=1&id=2a104543&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a104543",
  null
  
)

export default component.exports